import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import './Footer.scss';
import { FaFacebookF } from 'react-icons/fa';
import { AiOutlineInstagram, AiOutlineWhatsApp } from 'react-icons/ai';

const Footer = () => {
  return (
    <div className='footer'>
      <Container>
        <Row>
          <Col xs={{ span: 12, order: 2 }} md={{ span: 3, order: 1 }}>
            <p>House Of Arie 1</p>
          </Col>
          <Col xs={{ span: 12, order: 4 }} md={{ span: 3, order: 2 }}>
            <p>House Of Arie 2</p>
          </Col>
          <Col xs={{ span: 12, order: 1 }} md={{ span: 3, offset: 3, order: 3 }}>
            <div className='social-wrapper'>
              <a className='social-link' target='_blank' rel='noreferrer' href='https://www.facebook.com/HouseOfArie/'><FaFacebookF /></a>
              <a className='social-link' target='_blank' rel='noreferrer' href='https://www.instagram.com/house.of.arie/'><AiOutlineInstagram /></a>
              <a className='social-link' target='_blank' rel='noreferrer'
                 href='https://wa.me/6285780306440?text=Hi,%20saya%20ingin%20bertanya%20tentang%20House%20of%20Aries'><AiOutlineWhatsApp /></a>
              {/*<a className='social-link' target='_blank' href='mailto:houseofarie@gmail.com'><GrMail /></a>*/}
            </div>
          </Col>
          <Col xs={{ span: 12, order: 3 }} md={{ span: 3, order: 4 }}>
            <p>Jl. Depsos Gg. H. Mardan No.72, RW.1, Bintaro, Kec. Pesanggrahan, Kota Jakarta Selatan, Daerah Khusus
              Ibukota Jakarta 12330</p>
          </Col>
          <Col xs={{ span: 12, order: 5 }} md={{ span: 3, order: 5 }}>
            <p>Jl. Bhakti No.5, RT. 006/01, Bintaro, Pesanggrahan, Jakarta Selatan, DKI Jakarta Selatan</p>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Footer;
